var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "outer1 flex-col"
  }, [_c("div", {
    staticClass: "bd2 flex-row justify-between"
  }, [_c("div", {
    staticClass: "group1 flex-col",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    }
  })]), _c("span", {
    staticClass: "word1"
  }, [_vm._v("Brochure")])]), _c("div", {
    staticClass: "bd3 flex-col"
  }, [_c("div", {
    staticClass: "section1 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data01);
      }
    }
  }, [_c("div", {
    staticClass: "section2 flex-col"
  }), _c("span", {
    staticClass: "info2"
  }, [_vm._v("All New MG5")])]), _c("div", {
    staticClass: "section3 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data02);
      }
    }
  }, [_c("div", {
    staticClass: "group2 flex-col"
  }), _vm._m(0)]), _c("div", {
    staticClass: "section4 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data03);
      }
    }
  }, [_c("div", {
    staticClass: "wrap4 flex-col"
  }), _vm._m(1)]), _c("div", {
    staticClass: "section5 flex-row justify-between",
    on: {
      click: function click($event) {
        return _vm.toDetail(_vm.data04);
      }
    }
  }, [_c("div", {
    staticClass: "group4 flex-col"
  }), _c("span", {
    staticClass: "info3"
  }, [_vm._v("New MG EP Plus")])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "group3"
  }, [_c("span", {
    staticClass: "paragraph1"
  }, [_vm._v("New MG Extender"), _c("br")]), _c("span", {
    staticClass: "txt1"
  }, [_vm._v("(DC)")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wrap5"
  }, [_c("span", {
    staticClass: "infoBox1"
  }, [_vm._v("New MG Extender"), _c("br")]), _c("span", {
    staticClass: "word2"
  }, [_vm._v("(GC)")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };